import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputMoney, InputMultiline, InputSelect, Layout, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './transaction-model';  //editable..
import TransactiondetailList from '../transactiondetail/transactiondetail-list.component';
import TransactionamountList from '../transactionamount/transactionamount-list.component';
import TransactionpaymentList from '../transactionpayment/transactionpayment-list.component';
import JournalList from '../journal/journal-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    disableFields?: any;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class TransactionDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
    
    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} caption={this.props.caption} 
                model={Model} onLoad={this.onLoad} disableCard>              
                                                
                <Layout history={this.props.history} content={[
                    {caption: 'Details', hide: this.props.disableFields?.includes('transaction'), child: 
                    <>
                        <InputSelect name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Number' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {!this.props.disableFields?.includes('owner') && AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        }
                        {!this.props.disableFields?.includes('transactionType') &&
                        <InputPicklist name='transactiontype' label='Transaction Type' value={this.state.datarow.transactiontype} caption={this.state.datarow.transactiontypeCaption} readOnly/>
                        }
                        <InputDate name='transactiondate' label='Date' value={this.state.datarow.transactiondate} readOnly/>
                        {!this.props.disableFields?.includes('customer') &&
                        <InputPicklist name='customer' label='Customer' value={this.state.datarow.customer} caption={this.state.datarow.customerCaption} readOnly/>
                        } 
                        {!this.props.disableFields?.includes('vendor') &&
                        <InputPicklist name='vendor' label='Vendor' value={this.state.datarow.vendor} caption={this.state.datarow.vendorCaption} readOnly/>
                        }
                        {!this.props.disableFields?.includes('employee') &&
                        <InputPicklist name='employee' label='Employee' value={this.state.datarow.employee} caption={this.state.datarow.employeeCaption} readOnly/>
                        }
                        <InputPicklist name='division' label='Division' value={this.state.datarow.division} caption={this.state.datarow.divisionCaption} readOnly/>
                        <InputPicklist name='schedule' label='Schedule' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} readOnly/>
                    </>
                    },

                    {caption: 'Orders', hide: this.props.disableFields?.includes('transactiondetail','transactionamount'), child: 
                    this.state.datarow.id > 0 && this.props.history &&
                    <>
                        {!this.props.disableFields?.includes('transactiondetail') &&
                            <TransactiondetailList history={this.props.history} root={this.props.root} transactionId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                        }
                        {!this.props.disableFields?.includes('transactionamount') &&
                            <>
                            <TransactionamountList history={this.props.history} root={this.props.root} transactionId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/> 
                            <InputMoney name='totaldetail' label='Sub Total' value={this.state.datarow.totaldetail} readOnly/>
                            </>
                        }
                        {!this.props.disableFields?.includes('transactiondetail','transactionamount') &&
                            <InputMoney name='total' label='Total' value={this.state.datarow.total} size='medium' readOnly/>
                        }
                    </>
                    },

                    {caption:'Payments', hide: this.props.disableFields?.includes('transactionpayment'), child:
                    this.state.datarow.id > 0 &&
                        <>
                        <InputSelect name='statuspayment' label='' value={this.state.datarow.statuspayment} options={Model.optionStatuspayment} readOnly />
                        <TransactionpaymentList history={this.props.history} root={this.props.root} transactionId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/> 
                        <InputMoney name='total' label='Total Payment' value={this.state.datarow.totalpayment} readOnly/>
                        {this.state.datarow.statuspayment !== 'paid' &&
                            <InputMoney name='totalremaining' label='Remaining' value={this.state.datarow.totalremaining} readOnly/>
                        }
                        </>
                    },
 
                    {caption:'Journals', hide: this.props.disableFields?.includes('journal'), child:
                    this.state.datarow.id > 0 &&
                        <JournalList history={this.props.history} root={this.props.root} transactionId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/> 
                    },
  
                   ]}
                    
                />

            </BaseDelete>
        );
    }
}